module.exports = __webpack_public_path__ + "static/media/settings-contract.8ae1bf7d.png";